// Para que se ejecute Vue.use(VueCompositionApi) antes de import App (los imports se ejecutan antes que Vue.use)
import './installCompositionApi' 
import Vue from 'vue'
import App from './shared/App.vue'
import vuetify from './shared/vuetify'
import VueRouter from 'vue-router';
import { router } from './shared/router';

import './registerServiceWorker'

Vue.config.productionTip = false
Vue.use(VueRouter)

const mountEl: HTMLElement = document.querySelector('#app')

new Vue({
  router,
  vuetify,
  render: h => {
    const context = {
      props: {
        ...mountEl.dataset
      }
    }
    return h(App, context)
  }
}).$mount('#app')